
import React, { useState, useEffect } from 'react';
import { Box, Card, Divider, TableBody } from '@mui/material';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import axios from '../../../utils/fvAxios';
import { IconButton } from '@mui/material'
import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { ToastContainer, toast } from 'react-toastify';
import './CourseInstructions.css';
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

export default function CourseInstructions() {
    const formats = [
        "strike",
        "size",
        'font',
        'size',
        'bold',
        'italic',
        'underline',
        'background',
        'list',
        'align',
        'color',
        'indent',
        'clean',
        'blockquote', 'script'
    ];

    const modules = {
        toolbar: [
            ['undo', 'redo'],
            [{ 'size': [] }],
            [{ 'font': [] }],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            // ['link'],
            ['clean'],

            [{ 'color': [] }, { 'background': [] }],
            [{ 'align': [] }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
        ],
    };
    const toastNotify = (message, isSuccess = true) => {
        if (isSuccess) {
            toast.success(message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };

    const [Title, setTitle] = useState('');
    const [Description, setDescription] = useState('');
    const [Dis, setDis] = useState(false);
    const [spinner, setSpinner] = useState(false);
    const [trg, setTrg] = useState(false);

    const handleUndo = () => {
        const quill = quillRef.current.getEditor();
        quill.history.undo();
    };

    const handleRedo = () => {
        const quill = quillRef.current.getEditor();
        quill.history.redo();
    };
    const quillRef = React.createRef();


    useEffect(() => {
        setSpinner(true);
        axios
            .get("AdminVendors/GetCourseInstructions")
            .then((res) => {
                setDescription(res?.data?.data?.description);
                setTitle(res?.data?.data?.title);
                setSpinner(false);
                setTrg(false);
            })
            .catch((err) => {
                console.log(err);
                setSpinner(false);
            });

    }, [trg]);
    const isDescriptionEmpty = (html) => {
        if (!html) return true;

        const trimmed = html.trim().toLowerCase();

        return (
            trimmed === "<p><br></p>" ||
            trimmed === "<p><br/></p>" ||
            trimmed === "<p></p>"
        );
    };

    const SaveInstruction = async () => {

        if (!isDescriptionEmpty(Description) && Title != "") {
            setDis(true);
            setSpinner(true);
            const obj = {
                "title": Title,
                "description": Description
            }

            const res = await axios.post("AdminVendors/AddCourseInstructions", obj);
            if (res?.data?.responseCode == 100) {
                toastNotify(res?.data?.responseMessage, true);
                setDis(false);
                setTrg(true);
            } else {
                toastNotify(res?.data?.responseMessage, false);
                setDis(false);
                setSpinner(false);
            }
        } else {
            toastNotify("Please enter mandatory fields", false);
            setDis(false);
        }

    }


    return (
        <>
            <ToastContainer />
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={spinner}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Card>
                <div style={{ marginLeft: "10px", marginTop: "10px" }}>
                    <div style={{ marginLeft: "15px", marginBottom: "15px" }}>
                        <h3>Course Instructions</h3>
                    </div>
                </div>
                <Divider sx={{ marginTop: 2, marginBottom: 2, backgroundColor: "#667085;", height: "2px" }} />

                <Box >
                    <div className='mx-4'>
                        <span style={{ color: "#3E4A62" }}>Title  <span style={{ color: "red" }}>*</span></span>
                        <br />
                        <TextField
                            size='small'
                            sx={{ width: "320px" }}
                            value={Title}
                            onChange={(e) => setTitle(e?.target?.value)} />
                    </div>
                    <div className='mx-4 mt-3 '>
                        <span style={{ color: "#3E4A62" }}>Description  <span style={{ color: "red" }}>*</span></span>
                        {/* <CKEditor
                            editor={ClassicEditor}
                            data={"Google Map"}
                        onChange={(event, editor) => {
                            const data = editor.getData();
                            ChangeBody(data);
                            setBody(data)
                        }}
                        /> */}
                        <div>
                            <IconButton onClick={handleUndo} sx={{ marginBottom: "-64px" }}>
                                <UndoIcon />
                            </IconButton>
                            <IconButton onClick={handleRedo} sx={{ marginBottom: "-64px" }}>
                                <RedoIcon />
                            </IconButton>

                            <ReactQuill
                                ref={quillRef}
                                theme="snow"
                                modules={modules}
                                formats={formats}
                                value={Description}
                                onChange={setDescription}
                            />
                        </div>
                    </div>

                    <div className='mx-4 mt-3 mb-3 text-right'>
                        <Button variant="contained" sx={{ padding: "15px" }} disabled={Dis} onClick={SaveInstruction}> Save </Button>
                    </div>


                </Box >

            </Card>

        </>
    )
}


